import { Subscribable } from '@benzinga/subscribable';

export interface GetInfoItemsResult {
  items: { node: React.ReactNode; width: number }[];
}

export enum InfoBarPriority {
  Base = 0,
  Notification = 1,
}

export type InfoBarEvents = { type: 'force_content_change'; id: string };

export abstract class InfoBarModule extends Subscribable<InfoBarEvents> {
  public abstract id: string;
  public abstract name: string;
  public abstract getInfoItems: Generator<GetInfoItemsResult, GetInfoItemsResult, number>;
  public abstract priority: InfoBarPriority;
}
